import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        serviceCenterContainer: {
            flexDirection: 'column',
        },
        titleContainer: {
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: remCalc(24),
            py: remCalc(24),
        },
        button: {
            textStyle: 'body-small',
            p: '0',
            paddingInline: '0',
            height: 'auto',
            width: 'auto',
            justifyContent: 'flex-start',
            fontWeight: '400',
        },
        title: {
            textStyle: {base: 'head-large', lg: 'head-xlarge'},
            color: 'text.default',
            fontWeight: '500',
        },
        mapsLocatorContainer: {
            gap: {lg: remCalc(25)},
            flexDirection: {base: 'column', lg: 'row'},
        },
        serviceCenters: {
            flexDirection: 'column',
            gap: remCalc(16),
            maxH: {lg: remCalc(572)},
            maxWidth: {lg: remCalc(333)},
        },
        serviceCenterLocator: {
            flexDir: 'column',
            gap: remCalc(16),
            minW: {lg: remCalc(332)},
            maxW: {lg: remCalc(332)},
        },
        serviceCenterAddressMainContainer: {
            flexDirection: 'column',
            gap: {base: remCalc(8), lg: remCalc(24)},
            width: '100%',
            fontSize: remCalc(14),
            fontWeight: '400',
            color: 'text.default',
            paddingTop: remCalc(10),
        },
        serviceCenterAddressContainer: {
            flexDir: 'column',
            gap: remCalc(8),
            width: '100%',
            overflowY: {lg: 'scroll'},
            height: '100%',
        },
        serviceCenterAddress: {
            flexDirection: 'column',
            gap: remCalc(16),
            padding: remCalc(24),
            width: {base: '100%', lg: remCalc(312)},
            fontSize: remCalc(14),
            fontWeight: '400',
            color: 'text.default',
        },
        addressDescription: {
            textStyle: 'body-small',
            wordBreak: 'break-all',
        },
        inputFieldContainer: {
            position: 'relative',
        },
        searchIcon: {
            position: 'absolute',
            right: remCalc(15),
            top: remCalc(10),
            width: remCalc(24),
            height: remCalc(24),
            color: 'text.secondary',
        },
        chevronUpIcon: {
            width: remCalc(24),
            height: remCalc(24),
            display: {base: 'none', lg: 'block'},
        },
        inputField: {
            width: '100%',
            borderColor: 'border.table',
            fontSize: remCalc(12),
            color: 'text.secondary',
        },
        filtersButtonMainContainer: {
            width: '100%',
            display: 'flex',
            flexDir: 'column',
            gap: remCalc(8),
        },
        filtersContainer: {
            width: '100%',
            justifyContent: 'space-between',
            gap: {lg: remCalc(8)},
            alignItems: 'center',
        },
        filterIconContainer: {
            width: '100%',
            maxHeight: remCalc(40),
            maxWidth: {lg: remCalc(212)},
            justifyContent: {base: 'flex-end', lg: 'space-between'},
            padding: {base: `${remCalc(8)} ${remCalc(16)}`},
            gap: {base: remCalc(16), lg: 'unset'},
            background: {base: 'unset', lg: 'background.light'},
            fontSize: 'sm',
            cursor: 'pointer',
            flexDirection: {base: 'row-reverse', lg: 'row'},
            borderRadius: remCalc(4),
        },
        filterPopUpContainer: {
            justifyContent: 'flex-end',
            display: {base: 'flex', lg: 'none'},
            paddingTop: remCalc(12),
            paddingBottom: remCalc(10),
            w: '100%',
            gap: remCalc(100),
        },
        filterPopUpTitle: {
            textStyle: 'body-large',
            fontWeight: '500',
            w: '100%',
            textAlign: 'center',
        },
        filterPopUpCloseIcon: {
            position: 'absolute',
            right: remCalc(12),
            top: remCalc(24),
            w: remCalc(24),
            h: remCalc(24),
            display: {
                base: 'block',
                lg: 'none',
            },
        },
        checkboxCloseIcon: {
            w: remCalc(24),
            h: remCalc(24),
            pt: remCalc(3),
        },
        selectedFilterContainer: {
            gap: remCalc(8),
            flexWrap: {base: 'nowrap', lg: 'wrap'},
            maxWidth: {lg: remCalc(333)},
            overflowX: {base: 'scroll', lg: 'unset'},
        },
        selectedFilterItem: {
            width: 'fit-content',
            whiteSpace: 'nowrap',
            maxHeight: remCalc(50),
            justifyContent: 'space-between',
            padding: `${remCalc(9)} ${remCalc(16)}`,
            background: 'background.light',
            borderRadius: remCalc(4),
            fontSize: 'sm',
            cursor: 'pointer',
            alignItems: 'center',
            border: '2px',
            borderColor: 'background.secondary-hover',
        },
        filterItemsContainer: {
            height: '100%',
            overflowY: {lg: 'scroll'},
            width: '100%',
            gap: {lg: remCalc(8)},
        },
        filterSectionContainerMobile: {
            w: {base: '100%', lg: remCalc(312)},
            flexDir: 'column',
            alignItems: {base: 'center', lg: 'unset'},
            px: remCalc(16),
            bg: {base: 'unset', lg: 'background.light'},
            borderRadius: {base: 'unset', lg: remCalc(4)},
            gap: {base: remCalc(32), lg: remCalc(12)},
            borderBottom: {base: '1px solid #D4D4D4', lg: 'unset'},
            pt: {base: '0', lg: remCalc(16)},
            pb: {base: remCalc(21), lg: remCalc(16)},
        },
        distanceContainerMobile: {
            w: '100%',
            mt: remCalc(8),
            flexDir: 'column',
            alignItems: {base: 'center', lg: 'unset'},
            bg: {base: 'unset', lg: 'background.light'},
            borderRadius: {base: 'unset', lg: remCalc(4)},
            gap: {base: remCalc(26), lg: remCalc(12)},
        },
        filterByDistance: {
            w: '100%',
            paddingY: {base: remCalc(24), lg: 0},
        },
        distanceTitleContainer: {
            textStyle: 'body-large',
            fontWeight: '700',
            w: '100%',
            mb: {base: '0', lg: remCalc(8)},
        },
        radioButtonsContainer: {
            textStyle: 'body-small',
            lineHeight: remCalc(24),
            w: '100%',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        radioButtons: {
            w: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: remCalc(14),
            fontWeight: '400',
            lineHeight: remCalc(16),
        },
        checkboxesContainer: {
            flexDir: 'column',
            w: '100%',
            bg: {base: 'unset', lg: 'background.light'},
            borderRadius: '4px',
            gap: {base: remCalc(24), lg: remCalc(12)},
            maxH: {base: remCalc(135), lg: 'unset'},
        },
        checkboxesTitleContainer: {
            w: '100%',
            paddingY: {base: remCalc(24), lg: 0},
        },
        checkboxTitle: {
            textStyle: 'body-large',
            fontWeight: '700',
            w: '100%',
            mb: {base: '0', lg: remCalc(8)},
        },
        checkboxFilterItem: {
            w: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        checkbox: {
            w: remCalc(24),
            h: remCalc(24),
            borderRadius: remCalc(2),
        },
        showMoreResultsContainer: {
            width: '100%',
            padding: remCalc(16),
        },
        showMoreResultsButton: {
            bg: 'button.background.primary-default',
            border: remCalc(1),
            borderColor: 'text.secondary',
            borderStyle: 'solid',
            borderRadius: 'full',
            padding: `${remCalc(8)} ${remCalc(16)}`,
            color: 'white',
            display: {base: 'block', lg: 'none'},
            width: '100%',
        },
        removeAllButton: {
            display: {base: 'none', lg: 'block'},
            textAlign: 'center',
            padding: `${remCalc(9)} ${remCalc(16)}`,
            background: 'background.light',
            borderRadius: remCalc(4),
            fontSize: 'md',
            fontWeight: 500,
            textDecoration: 'underline',
            cursor: 'pointer',
            maxH: {base: remCalc(50), lg: remCalc(40)},
            whiteSpace: 'nowrap',
        },
        removeAllButtonMobile: {
            display: {base: 'block', lg: 'none'},
            textAlign: 'center',
            padding: `${remCalc(12)} ${remCalc(16)}`,
            background: 'background.light',
            borderRadius: remCalc(4),
            fontSize: 'md',
            fontWeight: 500,
            textDecoration: 'underline',
            cursor: 'pointer',
            margin: `${remCalc(8)} ${remCalc(0)}`,
        },
        storeResults: {
            textAlign: {base: 'center', lg: 'left'},
            color: '#757678',
            fontSize: 'sm',
        },
        locator: {
            padding: `${remCalc(8)} ${remCalc(16)}`,
            width: '100%',
            gap: remCalc(3),
            justifyContent: 'space-between',
            alignItems: 'center',
            border: remCalc(1),
            borderColor: 'border.secondary',
            borderStyle: 'solid',
            borderRadius: 'md',
            bg: 'white',
        },
        buttonLabel: {
            fontSize: remCalc(12),
            color: 'text.secondary',
        },
        hideMapButton: {
            maxH: {base: remCalc(40)},
            display: {base: 'flex', md: 'none'},
            bg: 'white',
            border: remCalc(1),
            borderColor: 'text.secondary',
            borderStyle: 'solid',
            borderRadius: 'full',
            padding: `${remCalc(13)} ${remCalc(16)}`,
        },
        filterContainerMobile: {
            height: {base: '100%', lg: 'unset'},
            width: {base: '100%', lg: 'unset'},
            zIndex: {base: '9999', lg: 'unset'},
            top: {base: '0', lg: 'unset'},
            left: {base: '0', lg: 'unset'},
        },
        filtersMobileVersion: {
            background: {base: 'white', lg: 'unset'},
            width: '100%',
            bottom: {base: '0'},
            left: {base: '0'},
            gap: remCalc(16),
            maxH: '100%',
            display: {base: 'flex', lg: 'block'},
            flexDirection: {base: 'column'},
            alignItems: 'center',
        },
        serviceCenterContact: {
            wordBreak: 'break-all',
            gap: {base: remCalc(16), lg: remCalc(8)},
        },
        viewMoreContainer: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(24),
        },
        viewMoreButton: {
            width: 'fit-content',
            minWidth: remCalc(227),
        },
        viewMoreText: {
            textStyle: 'body-medium',
            fontWeight: '400',
            color: 'text.default',
            textAlign: 'center',
            alignSelf: 'stretch',
        },
        addressIcons: {
            width: remCalc(16),
            height: remCalc(16),
        },
        mapContainer: {
            width: '100%',
            height: {base: remCalc(343), lg: '100%'},
        },
        mapTooltipContactButton: {
            display: 'flex',
            minH: remCalc(40),
            background: 'button.background.primary-default',
            border: 'none',
            borderColor: 'text.secondary',
            borderStyle: 'solid',
            borderRadius: 'full',
            padding: `${remCalc(8)} ${remCalc(16)}`,
            color: 'white',
            textAlign: 'center',
        },
        contactStoreButton: {
            maxH: {base: remCalc(40)},
            display: {base: 'block', lg: 'none'},
        },
        tooltipGoToMapsButton: {
            minH: remCalc(40),
            bg: 'white',
            border: remCalc(1),
            borderColor: 'text.secondary',
            borderStyle: 'solid',
            borderRadius: 'full',
            padding: `${remCalc(8)} ${remCalc(16)}`,
        },
        spinner: {
            justifyContent: 'center',
            py: remCalc(20),
        },
        label: {
            position: 'absolute',
            top: '50%',
            left: remCalc(16),
            transform: 'translateY(-50%)',
            transition: 'all 0.2s ease',
            textStyle: 'body-xsmall',
            color: 'gray.500',
        },
        labelActive: {
            top: '10%',
            transform: 'translateY(-100%)',
            paddingRight: remCalc(4),
            background: 'white',
        },
        serviceCenterInfoPopupButtons: {
            gap: remCalc(8),
            flexDirection: 'column',
        },
        '.pac-container input::placeholder': {
            color: 'transparent',
        },
    },
}
